"use client";
import { Link } from "react-router-dom";

/* ASSETS */
import Logo from "assets/images/logo.png";

const Header = () => {
  return (
    <header className="relative z-50 bg-white py-3 header-shadow">
      <div className="container">
        <div className="flex items-center justify-start xl:justify-center lg:justify-center">
          {/* LOGO */}
          <Link href="/" className="block">
            <img
              src={Logo}
              className="w-full h-16 mx-auto object-contain"
              alt="My Training Agency"
            />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
